import React from "react";
import {cx} from "../../../lib/ClassSet";
import "./StockItem.css";

const StockItem = (props) => {

  let {data} = props;
  let classes = cx({
    "item": true,
    "inventory-stock-list-item": true
  })

  return (
    <tr className={classes} onClick={(e) => props.onClick(data, e)}>
      <td className="field f-sku">{data.get("productSku")}</td>
      <td className="field">{data.get("productTitle")}</td>
      <td className="field f-quantity">{data.get("quantity")}</td>
    </tr>
  )
}

export default StockItem;